export default __webpack_public_path__ + "static/media/about.8064d082.jpg";